export default __webpack_public_path__ + "static/media/BANNER-FULL-MOBILE_Covid_01_Nasal.8dcad444.png";